import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService, DataService, FireForesightService, SiteTypeService } from 'src/api/services';
import { User,Customer, CustomerSummary, StatusType, Status, Incident, Widget, Note, SiteTwin, SiteParameter, Zone } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { Command } from 'src/api/models/command';
import { CommandParameter } from 'src/api/models/command-parameter';
import { ActivatedRoute } from '@angular/router';
import { IMultiSourceMultiValueWidget, TimeSeriesDetail } from 'src/app/models/dashboard';
import { AbstractDataService } from 'src/service/data.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { FireService } from 'src/service/fire.service';
import { MapComponent } from 'src/app/components/map/map.component';

//import * as L from 'leaflet';
import 'leaflet';
import 'leaflet-semicircle';
//import semiCircle from 'leaflet-semicircle';
import { isNumber } from 'highcharts';
import { FireCameraViewer } from 'src/app/components/fire-camera-viewer/fire-camera-viewer.component';

declare let L;
// todo: fix styles
// todo: install license

@Component({
  selector: 'app-fire-foresight-camera',
  templateUrl: './fire-foresight-camera.component.html',
  styleUrls: ['./fire-foresight-camera.component.css']
})
export class FireForesightCameraComponent implements OnInit {
  @ViewChild('map', { read: MapComponent, static: true }) map: MapComponent;
  @ViewChild('viewer', { read: FireCameraViewer, static: true }) viewer: FireCameraViewer;
  @ViewChild('livestream') private livestream: ElementRef<HTMLImageElement>;

  public list : StatusType[];
  public siteId: number;
  //public incident: Incident;
  public liveWidget: IMultiSourceMultiValueWidget;
  public latestImageUrl: string;
  public selectedNote: Note;
  public newNote: string;
  public expandImage: boolean = false;
  public mapExpand: boolean = false;
  public showFireDetection: boolean = false;
  public liveStreaming: boolean = false;
  public expandManualImage: boolean = false;
  public weatherMobileExpanded: boolean = false;

  constructor(
    public app: ApplicationConfigService, 
    public security: AzureAuthService,
    private svc: FireForesightService, 
    public fire: FireService,
    private data: DataService,
    private siteTypeService: SiteTypeService,
    private dataService: DataService,
    private toasterService: ToastrService,
    public auth: AzureAuthService,
    private route: ActivatedRoute) { 
    // console.log("fire-foresight-admin constructor")
  }

  ngOnInit(): void {    
    this.svc.FireForesightGetStatusTypes().subscribe(r=>{
      console.log("ngOnInit", r);
      this.list = r;
      // {statusId: 1, displayName: 'Unconfirmed', description: 'Initial state for all detections'}
    });

    this.route.params.subscribe(params => {
      this.siteId = params["siteId"];
      if (this.siteId){
        this.fire.getCamera(this.siteId, false, c => this.loadCamera(c));

      }
    });
  }

  toggleZones(){
    this.showZones = !this.showZones;
    //this.showFireDetection = !this.showFireDetection;
    if (this.showZones){
      this.loadIgnoreZones();
    }
    else{
      this.zones = null;
    }
  }

  showZones: boolean = false;
  zones:Zone[];
  loadIgnoreZones(){
    this.svc.FireForesightGetIgnoreZones({customerId: this.app.customerId, siteUri: this.fire.camera.siteUri}).subscribe(r => {
        this.zones = r;
    });
  }

  bearingChanged(bearing){
    // update the map to show the active bearing
    //console.log("Bearing Change:", bearing);
    var params = Object.values(this.fire.camera.twin.parameters).filter(f => !f.hidden);
    var step = params.find(p => p.bearing == bearing).fieldOfView;
    // /svar step = this.fire.camera.twin.metaData["fieldOfView"] ? parseInt(this.fire.camera.twin.metaData["fieldOfView"]) : (360 / params.length) / 2;
    //var step = (360 / params.length);
    this.map.displayBearing(this.fire.camera.twin, bearing, step);
  }

  displayDirection(bearing){
    console.log("Display Direction:", bearing);
    
    this.map.displayDirection(this.fire.camera.twin, bearing);
  }

  selectedImage: SiteParameter;
  imageChange(bearing){
    var details = Object.values(this.fire.camera.twin.parameters).find(t => t.bearing == bearing);
    console.log(this.fire.camera.twin.siteName + " Bearing Change : " + bearing);
    if (details){
      this.selectedImage = details;
    }
    //this.selectedImage = event;
  }

  tasAlertsSelected: boolean = false;
  tasAlerts: any;
  public toggleTasAlerts(){
    if (this.tasAlertsSelected == false){
      this.tasAlertsSelected = true;
      if (this.tasAlerts){
        this.map.showLayer(this.tasAlerts);
      } else {
        this.dataService.DataProxy("https://alert.tas.gov.au/data/data.geojson").subscribe(resp => {
          var tasAlerts = JSON.parse(resp);
          this.tasAlerts = this.map.loadLinkLayerContent('geojson', null, tasAlerts, null, null, 1024, false, feature => {
            //todo: show some details
          });
        }, err => {
          
        });
      }
    } else {
      if (this.tasAlerts){
        this.map.removeLayer(this.tasAlerts);
      }
      this.tasAlertsSelected = false;
    }
  }

  public mapHeight: number = window.innerHeight - 190;
  resizeMap(){
    const map = this.map.map;
    if(this.mapExpand)
    {
      this.mapHeight = window.innerHeight - 100;
    }
    else{
      this.mapHeight = window.innerHeight - 190;
    }
    setTimeout(function(){ map.invalidateSize()}, 50);
    
  }

  layersSelected: boolean = false;
  public toggleLayers(){
    if (this.layersSelected == false){
      console.log("Toggle Layers");
      // step through all layers and add
      if (this.fire.layers == null){
        this.svc.FireForesightGetMapLayers(this.app.customerId).subscribe(layers => {
          this.fire.layers = layers;
          if (this.fire.layers){
            this.toggleLayers();
          }
        });
      }
      else {
        this.layersSelected = true;
        for(let layer of this.fire.layers){

          if ((layer as any).layer == null){
            if (layer.layerTypeId == 1){
              // geojson
              this.data.DataProxy(layer.url).subscribe(resp => {
                var j = JSON.parse(resp);
                (layer as any).layer = this.map.loadLinkLayerContent('geojson', layer.mapLayerId, j, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, null);
              });
            }
            else if (layer.layerTypeId == 2){
              // kml/kmz
              if (layer.url.slice(-3).toLowerCase() == "kmz"){
                // KMZ files need to be fetched as binary, so pass URL directly
                var l = this.map.loadLinkLayerContent('kmz', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
                  
                });
                (layer as any).layer = l;
              } else {
                // KML files can be fetched as text
                this.data.DataProxy(layer.url).subscribe(resp => {
                    const parser = new DOMParser();
                    const kml = parser.parseFromString(resp, 'text/xml');
                    // Resolve relative href URLs against the original KML source
                    const hrefEls = kml.getElementsByTagName('href');
                    for (let i = 0; i < hrefEls.length; i++) {
                      const val = (hrefEls[i].textContent || '').trim();
                      if (val && !val.startsWith('http') && !val.startsWith('data:') && !val.startsWith('#')) {
                        try { hrefEls[i].textContent = new URL(val, layer.url).href; } catch {}
                      }
                    }
                    var l = this.map.loadLinkLayerContent('kml', layer.mapLayerId, kml, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
                      
                    });
                    (layer as any).layer = l;
                  }, err => {
                    //this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, error: true};
                  });
              }
            }
            else if (layer.layerTypeId == 3){
              // esri
              (layer as any).layer = this.map.loadLinkLayerContent('esri', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, null);
            }
            else if (layer.layerTypeId == 4){
              // cap
              this.data.DataProxy(layer.url).subscribe(resp => {
                var j = JSON.parse(resp);
                var l = this.map.loadLinkLayerContent('cap', layer.mapLayerId, j, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
                  
                });
                (layer as any).layer = l;
              }, err => {
                //this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, error: true};
              });
            }
            else if (layer.layerTypeId == 5){
              // wms
              var l = this.map.loadLinkLayerContent('wms', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
                
              });
              (layer as any).layer = l;
            }
          }

          /*if ((layer as any).layer != null){
            this.map.showLayer((layer as any).layer);
          }*/
        }
      }
      
    } else {
      if (this.fire.layers){
        //this.map.removeLayer(this.tasAlerts);
        this.layersSelected = false;
        //todo: step through all layers and remove
        for(let layer of this.fire.layers){
          if ((layer as any).layer){
            this.map.removeLayer((layer as any).layer);
            (layer as any).layer = null;
          }
        }
        
      }
      
    }
  }

  mode: number = 0;
  changeMode(mode: number) {
    this.showZones = false;
    if (this.mode == mode) {
      // this is a toggle back to the previous mode
      this.mode = 0;
      this.stopStream();
      return;
    }
    this.mode = mode;
    if (mode == 0) {
      // normal mode
    }
    else if (mode == 2) {
      // live mode
      this.liveStream();
    }
  }

   streamUrl: string;
  streamTimeout;
  timeout: number = 0;
  liveStream() {
    if (this.streamTimeout != null) {
      clearTimeout(this.streamTimeout);
      this.timeout = 0;
    }

    if (this.liveStreaming) {
      this.stopStream();
      //this.streamUrl = this.fire.camera?.manualCameraLatestUrl;
    } else {
      var cameraId = this.fire.camera?.siteId;
      if (cameraId == null) {
        return;
      }
      //this.streamUrl = "/assets/images/connecting.png";
      this.svc.FireForesightGetStreamKey({ customerId: this.app.customerId, siteId: cameraId }).subscribe(streamKey => {
        const finalStreamUrl = `/api/FireForesight/GetSecureStream/${streamKey}`;
        this.streamUrl = finalStreamUrl;

        this.streamTimeout = setInterval(() => {
          if (this.timeout >= 100) {
            this.liveStream();
            this.toasterService.success("Video Feed Timed Out");
            clearTimeout(this.streamTimeout);
            this.timeout = 0;
            setTimeout(() => {
              this.liveStreaming = false
              this.stopStream();
              this.mode = 0;
            }, 1000);
          } else {
            this.timeout = this.timeout + 0.25;
          }
        }, 200);
      }, err => {
        this.toasterService.error("Failed to start camera stream");
        this.liveStreaming = false;
        console.error("FireForesightGetStreamKey error:", err);
        this.streamUrl = null;
      });
    }

    this.liveStreaming = !this.liveStreaming;

    // todo: issue command to redirect camera in the direction of the incident

    //this.streamUrl = '/api/FireForesight/GetStream/' + this.app.customerId + '/' + this.fire.camera?.siteId;
    //this.liveStreaming = !this.liveStreaming;
  }

  private stopStream(): void {
    // Explicitly clear the image src to stop the browser from loading the stream
    if (this.livestream && this.livestream.nativeElement) {
      this.livestream.nativeElement.src = '';
    }
    this.streamUrl = null;
    this.liveStreaming = false;
  }

  loadCamera(camera){
    if (camera){
      console.log("FIRE CAMERA LOADED:", this.fire.camera);
      if (this.siteId != this.fire.camera.siteId){
        alert("Mismatch!!!");
      }
      this.map.displaySites([camera.twin], this.getIcon, null/*this.showView*/, null, true);
      this.viewer.refresh(camera.twin);

      this.loadIgnoreZones();
    }
  }

  getIcon(site: SiteTwin, pins: any[]){
    const icon = {icon: pins[site.siteType] ?? pins["blueSelected"]};
    return icon;
  }

  showView(site: SiteTwin) : any[]{
    if (site.siteType == "Fire Camera"){
      var items = [];
      var params = Object.values(site.parameters).filter(f => !f.hidden);
      var step = site.metaData["fieldOfView"] ? parseInt(site.metaData["fieldOfView"]) : (360 / params.length) / 2;
      for (let param of params){
        items.push(
          L.semiCircle([site.latitude, site.longitude], {
            radius: 20000,
            startAngle: param.bearing - (step),
            stopAngle: param.bearing + (step),
            lineColor: 'red'
          }));
      }
      return items;
    }
    return null;
  }

  setDayTimeImage(){
    if (confirm("Are you sure you want to set the daytime image? This will overwrite the current daytime image.")){
      this.svc.FireForesightSetDaytimeImage({
        customerId: this.app.customerId,
        siteId: this.siteId,
        cameraBearing: this.selectedImage.bearing,
        url: this.selectedImage.latestImageUrl
      }).subscribe({
        next: (result) => {
          if (result){
            this.toasterService.success("Daytime Image Set");
          } else {
            this.toasterService.error("Failed to set daytime image");
          }
        }
      });
    }
  }

  setAllDayTimeImage(){
    if (confirm("Are you sure you want to set all images as the daytime image? This will overwrite the current daytime images.")){
      for (let img of this.fire.camera.images){
        this.svc.FireForesightSetDaytimeImage({
          customerId: this.app.customerId,
          siteId: this.siteId,
          cameraBearing: img.bearing,
          url: img.latestImageUrl
        }).subscribe({
          next: (result) => {
            if (result){
              this.toasterService.success("Daytime Image Set for bearing " + img.bearing);
            } else {
              this.toasterService.error("Failed to set daytime image for bearing " + img.bearing);
            }
          }
        });
      }
    }
  }
}